import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBooking, IBookingInitialState } from "./bookingModel";
import {
  createPaymentOrder,
  deleteBooking,
  getAllBookings,
  getBookingByNo,
  getBookingDetailsByBookingNo,
  getPromoCodeDetails,
  saveTempTourBooking,
  saveTourBooking,
  sendBookingDetailByEmail,
  updateTourBooking,
  verifyPayment,
} from "./services/booking.services";

const initialState: IBookingInitialState = {
  loading: false,
  paymentLoading: false,
  promoapplyLoading: false,
  error: "",
  BookingID: null,
  BookingList: [],
  BookingDetails: {
    PaymentType: "Razorpay",
  },
  BookingViewDetails: {},
  PromoDetails: null,
};

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setBookingID: (state, action) => {
      state.BookingID = action.payload;
    },
    clearBookingID: (state) => {
      state.BookingID = initialState.BookingID;
    },
    clearBookingDetails: (state) => {
      state.BookingDetails = initialState.BookingDetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllBookings.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllBookings.fulfilled,
      (state, action: PayloadAction<IBooking[]>) => {
        state.loading = false;
        state.BookingList = action.payload || [];
      },
    );
    builder.addCase(getAllBookings.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BookingList = [];
    });

    builder.addCase(saveTempTourBooking.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(saveTempTourBooking.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(saveTempTourBooking.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(createPaymentOrder.pending, (state) => {
      state.paymentLoading = true;
      state.error = "";
    });
    builder.addCase(createPaymentOrder.fulfilled, (state) => {
      state.paymentLoading = false;
    });
    builder.addCase(createPaymentOrder.rejected, (state, action) => {
      state.paymentLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(verifyPayment.pending, (state) => {
      state.paymentLoading = true;
      state.error = "";
    });
    builder.addCase(verifyPayment.fulfilled, (state) => {
      state.paymentLoading = false;
    });
    builder.addCase(verifyPayment.rejected, (state, action) => {
      state.paymentLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(saveTourBooking.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(saveTourBooking.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(saveTourBooking.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateTourBooking.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateTourBooking.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateTourBooking.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getPromoCodeDetails.pending, (state) => {
      state.promoapplyLoading = true;
      state.error = "";
    });
    builder.addCase(getPromoCodeDetails.fulfilled, (state, action: any) => {
      state.promoapplyLoading = false;
      state.PromoDetails = action.payload;
    });
    builder.addCase(getPromoCodeDetails.rejected, (state, action) => {
      state.promoapplyLoading = false;
      state.PromoDetails = initialState.PromoDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getBookingDetailsByBookingNo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBookingDetailsByBookingNo.fulfilled, (state, action) => {
      state.loading = false;
      state.BookingViewDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getBookingDetailsByBookingNo.rejected, (state, action) => {
      state.loading = false;
      state.BookingViewDetails = null;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getBookingByNo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBookingByNo.fulfilled, (state, action) => {
      state.loading = false;
      state.BookingDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getBookingByNo.rejected, (state, action) => {
      state.loading = false;
      state.BookingDetails = null;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteBooking.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteBooking.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBooking.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(sendBookingDetailByEmail.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(sendBookingDetailByEmail.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(sendBookingDetailByEmail.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearBookingID, setBookingID, clearBookingDetails } =
  bookingSlice.actions;
export default bookingSlice.reducer;
